import React from "react";
import SrOnly from "../../../../../../../common-deprecated/styles/v2/toyota/utilities/ScreenreaderOnly";
// TODO: Move InteriorSpinStyle to common?
import * as InteriorSpinView from "../../step-customize/car-hero/styles/InteriorGalleryStyle";
import * as FilterStyles from "../styles/Filters";
import Preloader from "../../../../../../../common-deprecated/styles/toyota/Preloader";
import useProAceGallery from "../../../../hooks/proace/useProAceGallery";

const ProAceExteriorGallery = (): JSX.Element => {
    const { cacheKey, currentFrame, getImageSrc, imageCache, previousImg, setCurrentFrame, showPrevImg } =
        useProAceGallery();

    // Build images array. Animate and position the images by setting margins and css transitions.
    const images = imageCache.current.map((image) => {
        let margin;

        if (image.frame === currentFrame) margin = 0;
        else if (image.frame < currentFrame) margin = "-100%";
        else margin = "100%";

        return (
            <InteriorSpinView.SpinImage
                alt="Interior premium spin"
                key={cacheKey + image.frame}
                margin={margin}
                {...getImageSrc(image.frame)}
            />
        );
    });

    return (
        <FilterStyles.ExteriorGalleryWrapper>
            <InteriorSpinView.SpinInterior>
                <InteriorSpinView.SpinGallery>
                    <InteriorSpinView.SpinImages>
                        {previousImg.src && (
                            <InteriorSpinView.SpinImage
                                opacity={showPrevImg ? 1 : 0}
                                key={`${previousImg.cacheKey}-${previousImg.frame}`}
                                src={previousImg.src}
                                srcSet={previousImg.srcSet}
                                sizes={previousImg.sizes}
                                className="or-img-fluid or-spin-img"
                                alt="Interior gallery image"
                            />
                        )}
                        {images}
                        {imageCache.current[currentFrame].loading && <Preloader />}
                    </InteriorSpinView.SpinImages>
                    {imageCache.current.length > 1 && (
                        <InteriorSpinView.SpinNav>
                            {imageCache.current.map((image) => (
                                <FilterStyles.GalleryNavItem
                                    isActive={image.frame === currentFrame}
                                    key={`int-button-${image.frame}`}
                                    onClick={() => {
                                        setCurrentFrame(image.frame);
                                    }}
                                >
                                    <SrOnly>{image.frame + 1}</SrOnly>
                                </FilterStyles.GalleryNavItem>
                            ))}
                        </InteriorSpinView.SpinNav>
                    )}
                </InteriorSpinView.SpinGallery>
            </InteriorSpinView.SpinInterior>
        </FilterStyles.ExteriorGalleryWrapper>
    );
};

export default ProAceExteriorGallery;
